/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <path
      d="M505.778 234.827c6.321-5.352 6.272-13.979-.101-19.262L310.235 53.571c-6.378-5.286-11.548-2.852-11.548 5.431v104.406S.736 169.454.736 467.481c0 0 34.899-177.581 299.975-177.581l-.885 104.406c-.07 8.285 4.996 10.665 11.32 5.311l194.632-164.79z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconRightCurvedArrow = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconRightCurvedArrow.defaultProps = {
  theme,
};
IconRightCurvedArrow.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconRightCurvedArrow.displayName = 'IconRightCurvedArrow';
export { IconRightCurvedArrow };
